import React from 'react';

export interface ErrorScreenProps {
    error: string;
}

export const ErrorScreen = ({ error }: ErrorScreenProps) => {
    return <div>{error}</div>;
};
